import { IonCol, IonGrid, IonIcon, IonItem, IonRow, IonSpinner } from '@ionic/react'
import React, { useState } from 'react'
import { chevronDown, chevronUp } from 'ionicons/icons'
import { IReportAttachment } from '../store/ekgImport.types'
import { PhotoViewer } from '@capacitor-community/photoviewer'
import { IShowPhotoViewerProps } from '../../attachments/page/Attachments.page'
import '../eventItem/EventItem.component.css'
import '../reportItem/ReportItem.component.css'
import './ReportAttachment.component.css'
import { useDispatch } from 'react-redux'
import { getReportAttachmentImage } from '../store/ekgImport.actions'
import { useTranslation } from 'react-i18next'

interface IReportAttachmentProps {
  reportAttachment: IReportAttachment
}

const ReportAttachment: React.FC<IReportAttachmentProps> = (props: IReportAttachmentProps) => {
  const dispatch = useDispatch()
  const { t } = useTranslation()

  const { reportAttachment } = props

  const [isExpanded, setIsExpanded] = useState<boolean>(false)

  const onClick = async () => {
    if (!isExpanded) dispatch(getReportAttachmentImage(Number(reportAttachment?.id || '0')))

    setIsExpanded(!isExpanded)
  }

  const showPhotoViewer = (photoViewerProps: IShowPhotoViewerProps) => {
    const { src, alt } = photoViewerProps

    PhotoViewer.show({
      images: [
        {
          url: src || '',
          title: alt,
        },
      ],
      options: {
        share: false,
      },
    })
  }

  const renderReportImage = (imageString: string, alt: string) => {
    const src = `data:image/png;base64, ${imageString}`

    return (
      <div className='report-item-strip-image'>
        <img src={src} alt={alt} onClick={() => showPhotoViewer({ src, alt })} />
      </div>
    )
  }

  return (
    <IonItem className='event-item'>
      <div className='event-item-main'>
        <IonGrid className='report-attachment-grid'>
          <IonRow>
            <IonCol className='report-attachment-title'>{reportAttachment.description}</IonCol>
            <IonCol className='data-point event-more' onClick={onClick}>
              <IonIcon color='medium' className='event-more-icon' icon={isExpanded ? chevronUp : chevronDown} />
            </IonCol>
          </IonRow>
        </IonGrid>
      </div>

      {isExpanded && (
        <div className='report-attachment-item-strip'>
          {reportAttachment.data ? (
            <>{renderReportImage(reportAttachment.data, reportAttachment.description || '')}</>
          ) : (
            <>
              {reportAttachment.isLoading ? (
                <IonSpinner />
              ) : (
                <div className='report-item-strip-no-image'>{t('ekg.previewUnavailable')}</div>
              )}
            </>
          )}
        </div>
      )}
    </IonItem>
  )
}

export default ReportAttachment
